'use strict';

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _awaitAsyncGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure(function (api) {
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
      var options,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          result,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return _awaitAsyncGenerator(api.post('name/resolve', {
                timeout: options.timeout,
                signal: options.signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: path,
                  stream: true
                }, options)),
                headers: options.headers
              }));

            case 3:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 6;
              _iterator = _asyncIterator(res.ndjson());

            case 8:
              _context.next = 10;
              return _awaitAsyncGenerator(_iterator.next());

            case 10:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 14;
              return _awaitAsyncGenerator(_step.value);

            case 14:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 22;
                break;
              }

              result = _value;
              _context.next = 19;
              return result.Path;

            case 19:
              _iteratorNormalCompletion = true;
              _context.next = 8;
              break;

            case 22:
              _context.next = 28;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](6);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 28:
              _context.prev = 28;
              _context.prev = 29;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 33;
                break;
              }

              _context.next = 33;
              return _awaitAsyncGenerator(_iterator.return());

            case 33:
              _context.prev = 33;

              if (!_didIteratorError) {
                _context.next = 36;
                break;
              }

              throw _iteratorError;

            case 36:
              return _context.finish(33);

            case 37:
              return _context.finish(28);

            case 38:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 24, 28, 38], [29,, 33, 37]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
});